import { STATUS_TYPE } from '../../../enum';
import { AdvertisePackage } from '../../advertisePackage/api/interface';

interface InitialState {
  data: AdvertisePackage[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  hasMore: boolean;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 5,
  totalRecords: 0,
  currentPage: 0,
  hasMore: true,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
